export interface EditedAttendanceStatusFilterBarProps {
	selectedStatus: "all" | "present" | "late" | "absent"
	setSelectedStatus: (status: "all" | "present" | "late" | "absent") => void
}

export function EditedAttendanceStatusFilterBar({ selectedStatus, setSelectedStatus }: EditedAttendanceStatusFilterBarProps) {
	return (
		<div className="filter-bar">
			<span className="label">Statut</span>

			<button
				className={`btn btn-sm ${selectedStatus === "all" ? "btn-neutral" : "btn-ghost"}`}
				onClick={() => setSelectedStatus("all")}
			>
				Tous
			</button>
			<button
				className={`btn btn-sm ${selectedStatus === "present" ? "btn-neutral" : "btn-ghost"}`}
				onClick={() => setSelectedStatus("present")}
			>
				Présents
			</button>
			<button
				className={`btn btn-sm ${selectedStatus === "late" ? "btn-neutral" : "btn-ghost"}`}
				onClick={() => setSelectedStatus("late")}
			>
				En retard
			</button>
			<button
				className={`btn btn-sm ${selectedStatus === "absent" ? "btn-neutral" : "btn-ghost"}`}
				onClick={() => setSelectedStatus("absent")}
			>
				Absents
			</button>
		</div>
	)
}
